import { gql } from 'apollo-boost';

export const PUBLISH_PRODUCT_BASES = gql`
  mutation acceptProductBases($ids: [ID!]!) {
    acceptProductBases(ids: $ids)
  }
`;